import { Card, ScrollShadow } from '@nextui-org/react'
import { FC } from 'react'
import { TankChipContainer } from './TankChipContainer'
import { SubmitTankType } from '@/types/apiResponse/tankTypes'
import { useBatchStore } from '../../store/batch/useBatchStore'

export type TankModelContentProps = {
  groupIds: string[]
  instantSelect?: boolean
  onInstantSelect?: (tank: SubmitTankType) => void
  availableMap?: { [tankId: string]: string[] }
  singleSelect?: boolean
}

export const TankModalContent: FC<TankModelContentProps> = ({
  groupIds,
  instantSelect = false,
  onInstantSelect,
  availableMap,
  singleSelect = false,
}) => {
  const batches = useBatchStore((state) => state.batches)

  return (
    <Card
      className="my-2 rounded-lg bg-tdplbisque min-h-fit max-h-[50dvh] p-[0.75rem] border-tdpldarkgrey border-opacity-60 border-1 overflow-x-hidden"
      shadow="none"
      data-testid="tank-modal-content"
      role="dialog"
      aria-label="Tank selection modal"
    >
      <ScrollShadow className="w-full h-fit overflow-x-hidden" data-testid="tank-selection-scroll-area">
        {groupIds.map((groupId) => {
          if (groupId !== '$empty' && groupId !== '$ungrouped' && groupId !== '$ungrouped-zero-count' && groupId !== '$stocked')
            return (
              <TankChipContainer
                key={groupId}
                title={batches[groupId]?.batchName ?? groupId}
                groupId={groupId}
                instantSelect={instantSelect}
                onInstantSelect={onInstantSelect}
                availableMap={availableMap}
                singleSelect={singleSelect}
              />
            )
          else return null
        })}
        {groupIds.includes('$ungrouped') ? (
          <TankChipContainer title="Ungrouped Tanks" groupId={'$ungrouped'} singleSelect={singleSelect} />
        ) : null}
        {groupIds.includes('$ungrouped-zero-count') ? (
          <TankChipContainer title="Ungrouped Tanks (0 Count)" groupId={'$ungrouped-zero-count'} singleSelect={singleSelect} />
        ) : null}
        {groupIds.includes('$stocked') ? (
          <TankChipContainer title="Stocked Tanks" groupId={'$stocked'} singleSelect={singleSelect} />
        ) : null}
        {groupIds.includes('$empty') ? (
          <TankChipContainer title="Empty Tanks" groupId={'$empty'} singleSelect={singleSelect} />
        ) : null}
      </ScrollShadow>
    </Card>
  )
}
